import React from 'react';
import DialogMessage from '../../Dialog';
import { renderToString } from 'react-dom/server'
import { prettyDate } from '../../../utils/date';
import { handleInputMask } from '../../../utils/inputMasks';
import useStyles from "./styles";

const activeSchedulingsStructure = (data, classes) => {
    const { tableData, message, submessage } = data;

    return (
        <>
            <strong className={classes.modalMessage}>
            {message}
            </strong>
            <b className={classes.modalSubmessage}>{submessage}</b>
            <hr/>
            {tableData && Object.keys(tableData).map((key) => (
                <div key={key}>
                    <table style={{width: '100%'}}
                        data-cy={`client-quota-schedlings-conflict-${key}`}
                        id={`client-quota-schedlings-conflict-${key}`}
                        >
                        <thead>
                            <tr>
                                <td>Cliente: {tableData[key].client_name}</td>
                                { tableData[key].transporter_document &&
                                  <td>Transportadora: { handleInputMask('documentNumber',tableData[key].transporter_document) }</td> }
                            </tr>
                            <tr>
                                <td className={classes.textCenter}>Data</td>
                                <td className={classes.textCenter}>Quotas Alocadas</td>
                                <td className={classes.textCenter}>Agendamentos</td>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData[key].schedulings.map((value, index) => (
                                <tr key={index}>
                                    <td className={classes.textCenter}>{prettyDate(value.date)}</td>
                                    <td className={classes.textCenter}>{value.allocated}</td>
                                    <td className={classes.textCenter}>{value.updatedAlreadyScheduledQty}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <hr/>
                </div>
            ))}
        </>
    )
}

const ModalQuotaAlreadyScheduled = ({...props}) => {
    const classes = useStyles();

    const {isOpen, closeReadingNotificationDialog} = props
    const table = renderToString(activeSchedulingsStructure(props, classes))

    return <DialogMessage
                isOpen={isOpen}
                data-cy="client-quota-overload-feedback"
                id="client-quota-overload-feedback"
                closeReadingNotificationDialog={closeReadingNotificationDialog}
                message={table}
            >
    </DialogMessage>
}

export default ModalQuotaAlreadyScheduled;
